import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CarouselNavButton = forwardRef(({ direction = 'next', onClick, className, disabled = false }, ref) => {
    const isPrev = direction === 'prev';

    return (
        <button
            ref={ref}
            type="button"
            aria-label={isPrev ? 'Previous' : 'Next'}
            aria-disabled={disabled || undefined}
            disabled={disabled}
            className={classNames(
                'navigation__swiperBtn',
                isPrev ? 'navigation__swiperBtn--prev' : 'navigation__swiperBtn--next',
                disabled && 'navigation__swiperBtn--disabled',
                className
            )}
            onClick={disabled ? undefined : onClick}
        >
            {isPrev ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.5 19L8.5 12L15.5 5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.5 5L15.5 12L8.5 19"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </button>
    );
});

CarouselNavButton.displayName = 'CarouselNavButton';

CarouselNavButton.propTypes = {
    direction: PropTypes.oneOf(['prev', 'next']),
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

export default CarouselNavButton;
